// removed by extract-text-webpack-plugin
module.exports = {"ascending":"selectionTable__ascending__1Riwc","descending":"selectionTable__descending__vzU3O"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/SelectionTable/selectionTable.css
// module id = 972
// module chunks = 2